import React, { useState } from 'react';
import { SalvButton, SalvModal, Size } from '@salvapp/ui-components';
import { faRotateLeft } from '@fortawesome/pro-solid-svg-icons/faRotateLeft';
import { useEndFinalRiskOverride } from './riskActions';

export interface EndFinalRiskOverrideModalProps {
  personId: string;
}

const EndFinalRiskOverrideModal = ({ personId }: EndFinalRiskOverrideModalProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { mutateAsync: endOverride, isPending } = useEndFinalRiskOverride(personId);

  const submit = async () => {
    await endOverride();
    setShowModal(false);
  };

  return (
    <>
      <div>
        <SalvButton
          variant='secondary'
          size={Size.SMALL}
          onClick={() => setShowModal(true)}
          icon={faRotateLeft}
          label={'End override'}
        />
      </div>
      <form>
        <SalvModal show={showModal} onHide={() => setShowModal(false)}>
          <SalvModal.Header closeButton>End risk level override</SalvModal.Header>
          <SalvModal.Body>
            <div>Are you sure you want to end manual risk level override?</div>
          </SalvModal.Body>
          <SalvModal.Footer>
            <SalvButton variant='muted' onClick={() => setShowModal(false)} data-testid='cancel' label='No, keep it' />
            <SalvButton
              type='submit'
              variant='primary'
              onClick={submit}
              data-testid='confirm'
              disabled={isPending}
              label='Yes, end it!'
            />
          </SalvModal.Footer>
        </SalvModal>
      </form>
    </>
  );
};

export default EndFinalRiskOverrideModal;
